import "./BattleResultsItem.less";
import {useInjection} from "@dp-instant/ui";
import {GameModel} from "@game/coregame/model/GameModel";
import {TypesSocial} from "@dp-instant/interfaces";
import {ISocial, IUser, ScoreType} from "@dp-instant/social";
import {CTXLevelProgress} from "@game/coregame/interfaces/CTXLevelProgress";
import {TypesGame} from "@game/TypesGame";
import {math} from "@game/coregame/helpers";
import {ILeaderobardItemProps, ILeaderobardItemUser} from "@game/ui/interface/ILeaderBoardProps";
import cn from "classnames";

import {LeaderBoardItem} from "@game/ui/leaderboard/LeaderBoardItem";

type BattleResultItemProps = {scores: CTXLevelProgress} & ILeaderobardItemProps;

type BattleResultsProps = {passedStage: number; isLevelFinished: boolean};

export const BattleResults = ({passedStage, isLevelFinished = false}: BattleResultsProps) => {
    const social = useInjection<ISocial>(TypesSocial.model);
    const model = useInjection<GameModel>(TypesGame.model);
    const defaultHistory = () => ({
        c: model.currentContinent.stageLevel,
        l: model.currentContinent.data.id,
        s: model.currentContinent.data.stages.map(s => 0)
    });
    const getLevelHisotry = (u: IUser): CTXLevelProgress => {
        if (u === social.me) {
            return model.currentContinent.getHistory();
        }
        const extraData = u.scores.getEntry(ScoreType.CONTEXT)?.getExtraData();
        return extraData ? JSON.parse(extraData) : defaultHistory();
    };

    let compareFn = (a: BattleResultItemProps, b: BattleResultItemProps) => {
        return isLevelFinished
            ? math.array_summ(b.scores.s) - math.array_summ(a.scores.s)
            : b.scores.s[passedStage] - a.scores.s[passedStage];
    };

    let items: ILeaderobardItemProps[] = social.contextPlayers
        .map(u => ({
            user: {...u, name: u.name, image_url: u.photo, origin: u},
            scores: getLevelHisotry(u)
        }))
        .map(item => {
            if (isLevelFinished) {
                (item.user as ILeaderobardItemUser).score = math.array_summ(item.scores.s);
            } else {
                (item.user as ILeaderobardItemUser).score = item.scores.s[passedStage] || 0;
            }

            return item;
        })
        .sort(compareFn)
        .map((item, index) => ({...item, rank: index + 1}));

    return (
        <div className={cn("leaderboard")}>
            <ul className={cn("leaderboard__scroll")}>
                {items.map((item: ILeaderobardItemProps) => {
                    return <LeaderBoardItem user={item.user} rank={item.rank} isSolo={false} />;
                })}
            </ul>
        </div>
    );
};
